import { useState, useEffect } from 'react';
import { useOflowContext } from "../container";
import { OFlowModel } from "../model";
export const useCommand = (props = {}) => {
    const canvasModel = useCanvasModel(props);
    return canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.command;
};
export const useExectCommand = (fn, props) => {
    const command = useCommand(props);
    useEffect(() => {
        if (command) {
            fn(command);
        }
    }, [command]);
};
export const useCanvasInstance = (props = {}) => {
    const canvasModel = useCanvasModel(props);
    return canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.canvas;
};
export const useCanvasModel = (props = {}) => {
    var _a, _b;
    const { canvasId } = props;
    const { oFlowId } = props.oFlowId ? props : useOflowContext();
    const oFlowModel = OFlowModel === null || OFlowModel === void 0 ? void 0 : OFlowModel.getModel(oFlowId);
    const defaultCanvasModel = canvasId ? (_a = oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.getCanvasModel) === null || _a === void 0 ? void 0 : _a.call(oFlowModel, canvasId) : (_b = oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.getActiveCanvasModel) === null || _b === void 0 ? void 0 : _b.call(oFlowModel);
    const [canvasModel, setCanvasModel] = useState(defaultCanvasModel);
    useEffect(() => {
        const oFlowModel = OFlowModel === null || OFlowModel === void 0 ? void 0 : OFlowModel.getModel(oFlowId);
        const onActiveChange = () => {
            const canvasModel = canvasId ? oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.getCanvasModel(canvasId) : oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.getActiveCanvasModel();
            setCanvasModel(canvasModel);
        };
        onActiveChange();
        if (!canvasId) {
            oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.on('ACTIVE_CANVAS_CHANGE', onActiveChange);
        }
        return () => {
            oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.off('ACTIVE_CANVAS_CHANGE', onActiveChange);
        };
    }, []);
    return canvasModel;
};
export const useCanvasModelMount = (fn, props) => {
    const canvasModel = useCanvasModel(props);
    useEffect(() => {
        if (canvasModel) {
            fn(canvasModel);
        }
    }, [canvasModel]);
};
export const useEventCenter = (props = {}) => {
    const canvasModel = useCanvasModel(props);
    return canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.eventCenter;
};
export const useBindCanvasEvent = (key, fn, props) => {
    const eventCenter = useEventCenter(props);
    useEffect(() => {
        var _a;
        (_a = eventCenter === null || eventCenter === void 0 ? void 0 : eventCenter.on) === null || _a === void 0 ? void 0 : _a.call(eventCenter, key, fn);
        return () => {
            var _a;
            (_a = eventCenter === null || eventCenter === void 0 ? void 0 : eventCenter.off) === null || _a === void 0 ? void 0 : _a.call(eventCenter, key, fn);
        };
    }, [eventCenter]);
};
export const useBindCustomEvent = (key, fn, props) => {
    const eventCenter = useEventCenter(props);
    useEffect(() => {
        var _a;
        (_a = eventCenter === null || eventCenter === void 0 ? void 0 : eventCenter.onCustomEvent) === null || _a === void 0 ? void 0 : _a.call(eventCenter, key, fn);
        return () => {
            var _a;
            (_a = eventCenter === null || eventCenter === void 0 ? void 0 : eventCenter.offCustomEvent) === null || _a === void 0 ? void 0 : _a.call(eventCenter, key, fn);
        };
    }, [eventCenter]);
};
export const useOFlowModel = (props = {}) => {
    const { oFlowId } = props.oFlowId ? props : useOflowContext();
    const [oFlowModel, setOFlowModel] = useState(OFlowModel.getModel(oFlowId));
    useEffect(() => {
        if (!oFlowModel) {
            setOFlowModel(OFlowModel.getModel(oFlowId));
        }
    }, []);
    return oFlowModel;
};
export const useOFlowGlobalState = (props = {}) => {
    const oFlowModel = useOFlowModel(props);
    const [state, setState] = useState(oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.getGlobalState());
    useEffect(() => {
        oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.onGlobalDataChange(setState);
        return () => {
            oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.offGlobalDataChange(setState);
        };
    }, []);
    return [state, (fn) => {
            oFlowModel === null || oFlowModel === void 0 ? void 0 : oFlowModel.setGlobalState(fn);
        }];
};
//# sourceMappingURL=useModel.js.map